<div *ngIf="!isFormOnly">
    <p-accordion *ngIf="filterTemplate">
        <p-accordionTab header="Search Parameters">
            <app-form [templateSource]="filterTemplate" [configs]="filterConfig" (submit)="onFilterGrid($event)">
            </app-form>
        </p-accordionTab>
    </p-accordion>
    <app-cue-table *ngIf="tableColumnConfigs" [dataset]="tableSource" [gridOptions]="tableConfigs"
        [columnDefinitions]="tableColumnConfigs" [callback]="gridCallBacks"
        (onTableRowDoubleClicked)="onRowDoubleClicked($event)"
        (onSelectionChanges)="onGridSelectionChanges($event)"></app-cue-table>
</div>

<div *ngIf="isFormOnly">
    <app-form *ngIf="filterTemplate" [templateSource]="filterTemplate" [configs]="filterConfig"></app-form>
</div>

<div class="modal-footer2 col-md-12 align-right">
    <button [hidden]="config.data.hideSave" class="btn btn-primary margin-right-10 align-right" [disabled]="isDisabled"
        (click)="onClickOk()">OK</button>
    <button [hidden]="config.data.hideClose" class="btn btn-primary align-right" (click)="onClickClose()">CLOSE</button>

    <button class="btn btn-primary align-right" (click)="buttonClick(i)" *ngFor="let btnDetails of additionalButtonDetails; let i = index">{{btnDetails.buttonName}}</button>
</div>